import { Plane, useTexture } from "@react-three/drei";
import { useEffect, useRef } from "react";
import { EVENTS } from "./constants/events";
import { useSelector } from "react-redux";

function Events(props) {
  const eventTexture = useTexture(EVENTS[props.name]);
  const planeRef = useRef();

  const areEventsHidden = useSelector(
    (state) => state.configurator?.areEventsHidden
  );

  useEffect(() => {
    planeRef.current.material.alphaTest = 0.01;
  }, []);

  return (
    <group
      position={[0, 0.02, 0]}
      rotation-x={[-Math.PI * 0.5]}
      visible={areEventsHidden}
    >
      {/* <sprite >
        <spriteMaterial attach="material" map={eventTexture} />
      </sprite> */}
      <Plane ref={planeRef}>
        <meshStandardMaterial map={eventTexture} transparent />
      </Plane>
    </group>
  );
}

export default Events;
